import { Component, Input, OnInit, Optional } from '@angular/core';
import { FormControl, FormControlName, FormGroupDirective } from '@angular/forms';
import { InputSelectInterface } from '@shared/components/form/input-select/input-select.interface';

@Component({
  selector: 'app-input-select-radio',
  templateUrl: './input-select-radio.component.html',
  styleUrls: ['./input-select-radio.component.scss'],
})
export class InputSelectRadioComponent implements OnInit {
  @Input() useLabel = true;
  @Input() useColumn = false;
  @Input() rowClass = '';
  @Input() label!: string;
  @Input() options!: InputSelectInterface[];
  @Input() disable = false;

  // [FIX] form tidak lagi dibutuhkan setelah template beralih ke [formControl]="radioControl"
  // form: FormGroup;
  radioControl!: FormControl;

  constructor(
    private formGroupDirective: FormGroupDirective,
    @Optional() private formControlNameDirective: FormControlName
  ) {}

  // [OLD - COMMENTED] ControlName bisa return null saat change detection dipicu setValue() eksternal
  // get ControlName() {
  //   return this.formControlNameDirective?.name || null;
  // }

  ngOnInit(): void {
    // [OLD - COMMENTED] form tidak lagi dibutuhkan di template
    // this.form = this.formGroupDirective.form;
    if (this.formControlNameDirective) this.radioControl = this.formGroupDirective.getControl(this.formControlNameDirective);
  }
}
